export default __webpack_public_path__ + "static/media/M1.6e25a905.svg";